import React from 'react';
import { utilHelper } from '../../helpers';
import MoreVertIcon from '@material-ui/icons/MoreVert';

function CheckedOpbList({ opbList, setSelectedOpbInfo }) {

    return (
        <>
            {opbList.map(opb =>
                <div className="checkedOpbList-item" key={opb.opbID} >
                    <div className="checkedOpbList-item-name" >
                        <div>[{opb.opbNo}호기] {utilHelper.getCodeName(opb.slotCode)}</div>
                    </div>
                    <div className="checkedOpbList-item-more" onClick={() => { setSelectedOpbInfo(opb.opbID); }}>
                        <MoreVertIcon />
                    </div>
                </div>
            )}
        </>
    );
}

export default CheckedOpbList;